export const FLITCH_INVENTORY_REQUEST = "FLITCH_INVENTORY_REQUEST";
export const FLITCH_INVENTORY_SUCCESS = "FLITCH_INVENTORY_SUCCESS";
export const FLITCH_INVENTORY_FAILED = "FLITCH_INVENTORY_FAILED";
export const FLITCH_HISTORY_INVENTORY_REQUEST = "FLITCH_HISTORY_INVENTORY_REQUEST";
export const FLITCH_HISTORY_INVENTORY_SUCCESS = "FLITCH_HISTORY_INVENTORY_SUCCESS";
export const FLITCH_HISTORY_INVENTORY_FAILED = "FLITCH_HISTORY_INVENTORY_FAILED";
